import type { RefObject } from "react";
import styles from "./PillButton.module.css";

export interface PillButtonProps {
  label: string;
  value: string;
  isActive: boolean;
  isOpen: boolean;
  triggerRef: RefObject<HTMLButtonElement | null>;
  onClick: () => void;
  testId: string;
}

export function PillButton({
  label,
  value,
  isActive,
  isOpen,
  triggerRef,
  onClick,
  testId,
}: PillButtonProps) {
  const className = [styles.pill, isActive || isOpen ? styles.pillActive : ""]
    .filter(Boolean)
    .join(" ");

  const chevronClass = [styles.chevron, isOpen ? styles.chevronOpen : ""]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      ref={triggerRef}
      type="button"
      className={className}
      onClick={onClick}
      data-testid={testId}
    >
      <span className={styles.pillLabel}>{label}:</span>
      {value}
      <span className={chevronClass} aria-hidden="true">
        &#9662;
      </span>
    </button>
  );
}
